// Top hero for the blog index — eyebrow + title + dek.
export function BlogIndexHero() {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#FAFAFF_0%,#FFFFFF_100%)] px-[clamp(24px,5vw,80px)] pt-[clamp(56px,7vw,96px)] pb-[clamp(32px,4vw,56px)]">
      <div className="relative mx-auto max-w-[1180px]">
        <div className="relative z-[1] max-w-[720px]">
          <div className="mb-5 flex items-center gap-3">
            <div className="h-px w-8 bg-indigo-300" />
            <div className="font-body text-xs font-semibold uppercase tracking-[0.14em] text-indigo-700">
              The Companion blog
            </div>
          </div>
          <h1 className="font-companion m-0 text-[clamp(40px,5.5vw,64px)] font-bold leading-[1.05] tracking-[-0.03em] text-primary [text-wrap:balance]">
            Notes from the team building Companion.
          </h1>
        </div>
      </div>
    </section>
  );
}
